import React from 'react'
import { withTranslation } from 'react-i18next'
import CinemaPlatform from '../../components/Cinema/CinemaPlatform.jsx'
import { ArrowSquareRight } from 'phosphor-react'
import PropTypes from 'prop-types'
import { Card, CardBody, CardFooter, CardImg, Col } from 'reactstrap'
import styled from 'styled-components'
import Skeleton from '../UI/Skeleton.jsx'

const HoverSpan = styled.span`
    &:hover {
        cursor: pointer;
    }
`

class CinemaCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            imageLoaded: false,
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
        }
        this.handleClick = this.handleClick.bind(this)
        this.link = `/cinema/${this.props.name}`
    }

    handleClick(event) {
        event.preventDefault()
        this.props.props.history.push(`/film/${this.props.id}`)
    }

    render() {
        const { t } = this.props
        return (
            <Col sm={12} ms={6} lg={6} xl={4} md={6} className="cinema-card d-flex align-items-stretch">
                {
                    this.props.skeleton ?
                        <Card className="d-flex flex-column">
                            <Skeleton height={250} className='card-img cinema-img' image={true} />
                            <CardBody className="news-content cinema-content border-0">
                                <div className="news-date xs-font-size"><Skeleton width={'40%'} /></div>
                                <span className="news-title md-font-size"><Skeleton width={'50%'} /></span>
                                <div className="news-desc md-font-size"><Skeleton count={5} /></div>
                                <div className="cinema-platforms">
                                    <CinemaPlatform skeleton={true} />
                                    <CinemaPlatform skeleton={true} />
                                    <CinemaPlatform skeleton={true} />
                                </div>
                            </CardBody>
                            <CardFooter className="mt-auto">
                                <div className="news-white-space"></div>
                                <Skeleton className="btn cinema-btn watch" button={true} />
                            </CardFooter>
                        </Card>
                        :
                        <Card className="d-flex flex-column">
                            {!this.state.imageLoaded && this.props.image && <Skeleton className='card-img cinema-img' height={250} image={true} />}
                            {this.props.image && <CardImg onLoad={() => this.setState({ imageLoaded: true })} src={`${this.state.imageUrl}/${this.props.image}`} alt="" className={`cinema-img${this.state.imageLoaded ? '' : ' d-none'}`} onClick={this.handleClick} />}
                            <CardBody className="news-content cinema-content border-0">
                                <div className="news-date xs-font-size">{this.props.year ? `${t('cinema-premiere')} ${this.props.year} ${t('cinema-year')}`:''} </div>
                                <HoverSpan className="news-title md-font-size" onClick={this.handleClick}>
                                    {this.props.name}
                                </HoverSpan>
                                <div className="news-desc md-font-size" dangerouslySetInnerHTML={{
                                    __html: this.props.desc,
                                }}>
                                </div>
                                <div className="cinema-platforms">
                                    {this.props.platforms.map((platform, index) => (
                                        <CinemaPlatform
                                            key={platform.id ? `platform-${platform.id}` : `noPlatformId-${index}`}
                                            name={platform.name}
                                            link={platform.link}
                                            filmName={this.props.name}
                                        />
                                    ))}
                                </div>
                            </CardBody>
                            <CardFooter className="mt-auto">
                                <div className="news-white-space"></div>
                                <div className="btn cinema-btn watch" onClick={this.handleClick}>
                                    <div className="cinema-btn-content">
                                        <span className="cinema-btn-desc sm-font-size">{t('news-read-more')}</span>
                                        <ArrowSquareRight size={20} color="#FFFFFF" />
                                    </div>
                                </div>
                            </CardFooter>
                        </Card>
                }
            </Col>
        )
    }
}

CinemaCard.propTypes = {
    name: PropTypes.string,
    props: PropTypes.object,
    image: PropTypes.string,
    year: PropTypes.number,
    platforms: PropTypes.array,
    desc: PropTypes.string,
    t: PropTypes.func,
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    skeleton: PropTypes.bool,
}

export default withTranslation()(CinemaCard)



// WEBPACK FOOTER //
// ./src/components/Cinema/CinemaCard.jsx